import { render, staticRenderFns } from "./listChannel.vue?vue&type=template&id=b398a750&"
import script from "./listChannel.vue?vue&type=script&lang=js&"
export * from "./listChannel.vue?vue&type=script&lang=js&"
import style0 from "./listChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports